module.exports = __webpack_public_path__ + "static/desktop/img/material-5.86e7f689.jpg";